import { map, shareReplay, take, switchMap, filter } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { ImageViewerService } from 'src/app/core/services/image-viewer.service';
import { Attachment } from 'src/app/core/models/attachment.model';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttachmentsComponent implements OnInit {

  @Input()
  set attachments(attachments: Attachment[]) {
    this.attachments$.next(attachments);
  }

  attachments$ = new BehaviorSubject<Attachment[]>([]);
  images$ = this.getImages();

  @Output() uploaded = new EventEmitter<Attachment>();
  @Output() removed = new EventEmitter<string>();

  constructor(
    private imageViewerService: ImageViewerService
  ) { }

  ngOnInit(): void {
  }

  trackByFn(index, item) {
    return item.path;
  }

  viewAttachments(index: number) {
    const attachments = this.attachments$.getValue();
    if (attachments[index]?.downloadURL) {
      this.images$.pipe(
        take(1),
        switchMap(images => this.imageViewerService.openImageViewerDialog(images, index)),
        filter(removeImageURL => !!removeImageURL),
      ).subscribe(removeImageURL => {
        const removedImage = attachments.find(attachment => attachment.downloadURL === removeImageURL);
        this.removed.emit(removedImage.path);
      });
    }
  }

  private getImages(): Observable<string[]> {
    return this.attachments$.pipe(
      map(attachments => {
        return attachments.filter(attachment => attachment.downloadURL)
          .map(attachment => attachment.downloadURL);
      }),
      shareReplay(1)
    );
  }

}
